"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../controllers/BaseController");
var DlgSelectKeyValueItemCtl = /** @class */ (function (_super) {
    __extends(DlgSelectKeyValueItemCtl, _super);
    function DlgSelectKeyValueItemCtl() {
        return _super.call(this, true) || this;
    }
    DlgSelectKeyValueItemCtl.prototype.ResetData = function () {
        this.DATA = {
            onClose: null,
            onSelect: null,
            onReLoadData: null,
            visible: false,
            hideReLoadButton: false,
            data: [],
            title: "",
            columnValueTitle: "",
            notAutoCloseDialog: false,
            hideNotAutoCloseDialog: false
        };
    };
    DlgSelectKeyValueItemCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgSelectKeyValueItemCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgSelectKeyValueItemCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgSelectKeyValueItemCtl.prototype, "onClose", {
        get: function () {
            return this.DATA.onClose;
        },
        enumerable: true,
        configurable: true
    });
    DlgSelectKeyValueItemCtl.prototype.SetOnCloseClick = function (callback) {
        this.DATA.onClose = callback;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgSelectKeyValueItemCtl.prototype, "OnSelect", {
        get: function () {
            return this.DATA.onSelect;
        },
        enumerable: true,
        configurable: true
    });
    DlgSelectKeyValueItemCtl.prototype.SetOnSelectClick = function (callback) {
        this.DATA.onSelect = callback;
        this.Update();
        return this;
    };
    DlgSelectKeyValueItemCtl.prototype.SetOnReLoadData = function (callback) {
        this.DATA.onReLoadData = callback;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgSelectKeyValueItemCtl.prototype, "onReLoadData", {
        get: function () {
            return this.DATA.onReLoadData;
        },
        enumerable: true,
        configurable: true
    });
    DlgSelectKeyValueItemCtl.prototype.SetTitle = function (title) {
        this.DATA.title = title;
        this.Update();
        return this;
    };
    DlgSelectKeyValueItemCtl.prototype.SetColumnValueTitle = function (title) {
        this.DATA.columnValueTitle = title;
        this.Update();
        return this;
    };
    DlgSelectKeyValueItemCtl.prototype.SetViewData = function (data) {
        this.DATA.data = data;
        this.Update();
        return this;
    };
    DlgSelectKeyValueItemCtl.prototype.SetReLoadButtonVisible = function (visible) {
        this.DATA.hideReLoadButton = !visible;
        this.Update();
        return this;
    };
    DlgSelectKeyValueItemCtl.prototype.SetNotAutoCloseDialog = function (notAutoClose) {
        this.DATA.notAutoCloseDialog = notAutoClose;
        this.Update();
        return this;
    };
    DlgSelectKeyValueItemCtl.prototype.SetHideNotAutoCloseDialog = function (hideNotAutoClose) {
        this.DATA.hideNotAutoCloseDialog = hideNotAutoClose;
        this.Update();
        return this;
    };
    return DlgSelectKeyValueItemCtl;
}(BaseController_1.BaseController));
exports.DlgSelectKeyValueItemCtl = DlgSelectKeyValueItemCtl;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ctl/DlgSelectKeyValueItemCtl.ts
// module id = 894
// module chunks = 0